<template>
  <div class="theme">{{ lib.libName }}</div>
  <table border="1" class="plan-table">
    <tr>
      <template v-for="(item, index) in tableColunms" :key="index">
        <th :rowspan="index + 1 === tableColunms.length ? 1 : 2">
          {{ item.label }}
        </th>
      </template>
    </tr>

    <tr>
      <th>
        <a-space>
          <a-button size="small" @click="handleUpdateLib(null, lib.libName)"
            >添加文件</a-button
          >
          <!-- <a-button size="small" @click="handleDeleteLib(lib)" type="danger"
            >删除主题</a-button
          > -->
        </a-space>
      </th>
    </tr>

    <template v-for="fileKey in ['inputFiles', 'outputFiles']" :key="fileKey">
      <template v-for="(item, index) in lib[fileKey]" :key="index">
        <tr>
          <td v-if="index === 0" :rowspan="lib[fileKey].length">
            {{ fileKey === "inputFiles" ? "输入" : "输出" }}
          </td>
          <td v-if="item.rowspan" :rowspan="item.rowspan" class="file-name">
            {{ item.fileName }}
          </td>
          <td v-else-if="item.rowspan !== null" class="file-name">
            {{ item.fileName }}
          </td>

          <!-- 版本 -->
          <td class="file-version">
            {{ item.version }}

            <a-tooltip placement="top" class="add-icon">
              <template #title>
                <span>版本迭代</span>
              </template>
              <PlusSquareOutlined @click="handleUpdateLib(item, null, true)" />
            </a-tooltip>
          </td>
          <td>
            <a-button @click="handleToDownload(item)" size="small"
              >下载</a-button
            >
          </td>

          <td>
            <a-tooltip placement="top" v-if="item.toUsers">
              <template #title>
                <span>已推送 {{ item.toUsers }}</span>
              </template>
              <a-button @click="hanldeTopush(item)" size="small">推送</a-button>
            </a-tooltip>

            <a-button v-else @click="hanldeTopush(item)" size="small"
              >推送</a-button
            >
          </td>

          <!-- 工作记录 -->
          <td class="work-records">
            {{ item.workRecords }}
          </td>
          <!-- 设计人 -->
          <td>
            {{ item.username }}
          </td>
          <!-- 上传时间 -->
          <td>
            {{ item.uploadTime }}
          </td>
          <!-- 产线资料	-->
          <td>
            {{ item.isProductionData ? "是" : "否" }}
          </td>
          <!-- 体系资料 -->
          <td>
            {{ item.isSystemData ? "是" : "否" }}
          </td>
          <!-- 操作 -->
          <td class="action">
            <a-space>
              <a-button
                type="primary"
                size="small"
                @click="handleUpdateLib(item)"
                :disabled="user.id !== item.userId"
                >更新</a-button
              >
              <a-button
                type="danger"
                size="small"
                :disabled="user.id !== item.userId"
                @click="handleDeleteLib(item)"
                >删除</a-button
              >
            </a-space>
          </td>
        </tr>
      </template>
    </template>
  </table>
  <notice-staff
    ref="noticeStaffRef"
    @handleSelectStaff="handleSelectStaff"
    :multiple="true"
  ></notice-staff>
</template>

<script>
import { defineComponent, inject, reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import websocket from "@/utils/base/socket";
import { Toast, timeStampToTime } from "@/utils/index";
import { tableColunms } from "@/views/rdmanagement/components/database/options";
import { deleteDataLib, updateDataLib } from "@/request/view/project";
import { showModal } from "@/views/repairprogress/serve/modal";
import { download } from "@/views/rdmanagement/serve/index";
import { PlusSquareOutlined } from "@ant-design/icons-vue";
import noticeStaff from "@/components/chooseStaff/index.vue";

export default defineComponent({
  components: { noticeStaff, PlusSquareOutlined },
  props: {
    libData: Object,
  },
  setup(props, context) {
    const handleToDownload = (record) => {
      if (record.fileLink) {
        record.fileLink.split(",").forEach((file) => {
          download(record.fileLink, "文件");
        });
      }
    };
    const activeKey = inject("activeKey");
    const dataBaseKey = inject("dataBaseKey");
    const route = useRoute();
    const user = useStore().state.user.user;
    const noticeStaffRef = ref();
    const lib = reactive({
      inputFiles: [],
      outputFiles: [],
      libName: null,
    });

    const { handleUpdateLib } = inject("actionOptions");

    const handleDeleteLib = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteDataLib([record.id]).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            context.emit("updateTable");
          });
        },
      });
    };

    let cacheRecord = null;
    const hanldeTopush = (record) => {
      cacheRecord = record;
      noticeStaffRef.value.showModal();
    };

    const handleSelectStaff = (staffId, staffName, staffUserName) => {
      const nickName = user.nickName;
      const localTime = timeStampToTime("", "minutes");
      const { fileName, id, fileLink, version, username, userId, toUsers } =
        cacheRecord;

      const query = Object.assign(
        {
          id,
          activeKey: "资料库",
          type: "link",
          fileLink,
          fileName,
          version,
          username,
        },
        route.query
      );
      query.userId = userId;

      websocket.Send({
        content: `${nickName}在${localTime}推送${fileName}`,
        query: JSON.stringify(query),
        route: "/rdprojectlayout",
        messageSort: "资料库",
        toUserId: staffId,
        type: 0,
        userId: user.id,
      });

      if (toUsers) {
        const userlist = toUsers.split(",");
        staffName.push(...userlist);
      }

      updateDataLib({
        id: cacheRecord.id,
        toUsers: Array.from(new Set(staffName)).toString(),
      }).then((res) => {
        context.emit("updateTable");
      });
    };

    watch(
      () => props.libData,
      (val) => {
        const { inputFiles, libName, outputFiles } = val;
        lib.libName = libName;
        lib.inputFiles.length = 0;
        lib.inputFiles.push(...inputFiles);
        lib.outputFiles.length = 0;
        lib.outputFiles.push(...outputFiles);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      lib,
      user,
      noticeStaffRef,
      handleSelectStaff,
      tableColunms,
      hanldeTopush,
      handleToDownload,
      handleUpdateLib,
      handleDeleteLib,
    };
  },
});
</script>

<style lang="less" scoped>
.theme {
  text-align: left;
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: 600;
}
.plan-table {
  margin: 20px 0;
  th,
  td {
    padding: 7px 10px;
    text-align: center;
  }
  th {
    font-size: 17px;
  }
}
.tasks-title {
  width: 120px;
}
.file-name {
  width: 150px;
}
.file-version {
  width: 100px;
  position: relative;
  .add-icon {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 20px;
    height: 20px;
  }
}
.work-records {
  width: 300px;
}
.action {
  width: 160px;
}
</style>
